import { Box, Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import { setTransportConditionCheckedType } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTransportConditionFilterList = () => {
  const dispatch = useDispatch();
  const checkedType = useSelector((state) => state.map.transportConditionFilterCheckedType);

  const handleChange = (event) => dispatch(setTransportConditionCheckedType(event.target.name));

  return (
    <Box
      component='ul'
      sx={(theme) => ({
        display: 'flex',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '10px',
        width: '100%',
        listStyle: 'none',
        position: 'relative',
        padding: '0 12px',
        margin: theme.spacing(0),
        '.MuiFormLabel-root': {
          marginBottom: '6px',
          fontSize: '12px',
          '&.Mui-focused': {
            color: 'text.secondary',
          },
        },
        '.MuiFormControlLabel-root': {
          userSelect: 'none',
          margin: theme.spacing(0),
          padding: theme.spacing(0),
          '.MuiCheckbox-root': {
            padding: theme.spacing(0),
            marginRight: '4px',
          },
        },
        '.MuiFormControlLabel-label': {
          whiteSpace: 'nowrap',
        },
      })}>
      <FormControl component='fieldset' variant='standard'>
        <FormGroup>
          <FormControlLabel
            label='Все события'
            control={<Checkbox size='small' name='all' disableRipple onChange={handleChange} checked={checkedType === 'all'} />}
          />
        </FormGroup>
      </FormControl>
      <FormControl component='fieldset' variant='standard'>
        <FormGroup>
          <FormControlLabel
            label='Фильтры'
            control={<Checkbox size='small' name='filter' disableRipple onChange={handleChange} checked={checkedType === 'filter'} />}
          />
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default MapTransportConditionFilterList;
